import colors from '@/shared/colors';

export default {
    computed: {
        colors() {
            return colors;
        }
    }
};
